<template>
  <account-information-form></account-information-form>
</template>

<script>
  // // @ is an alias to /src
  import AccountInformationForm from '@/components/AccountInformationForm'
  
  export default {
    components:{
      'account-information-form' : AccountInformationForm
    },

    name: 'accountInformation',
    
    data () {
      return {
      }
    }
  }
</script>
